import script from "./ActiveListTag.vue?vue&type=script&setup=true&lang=js"
export * from "./ActiveListTag.vue?vue&type=script&setup=true&lang=js"

import "./ActiveListTag.vue?vue&type=style&index=0&id=74a12c24&lang=less&scoped=true"

import exportComponent from "G:\\website\\work\\xmjh\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74a12c24"]])

export default __exports__